import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import printJS from 'print-js'
import Printd from 'printd'
import CryptoJS from 'crypto-js'


import {
  Validator
} from 'vee-validate'
export default {
  name: 'printmanifestdetails',
  components: {
    Paginate,
  },
  props:['id','clientid','warehouseid','clientid1'],
  data: function() {
    return {
      // initialize form field
      isLoading: false,
      paginationflag: true,
      listOrderMasterdata: [],
      clientdata: [],
      totalAWBNO: [],
      logoUrl: '',
      pagecount: 0,
      pageno: 0,
      currentPage: 0,
      loading: false,
      loadingText: '<i class="fa fa-spinner fa-spin"></i> Loading...',
      // warehouseid: ''
    }
  }, // end data

  computed: {

  }, // end computed

  created: function() {
    // when a page loads,mounted() will be call
  },
  mounted() {
    var permissionEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.user_type = userdetail.utype;
    this.getPrintManifestData()

  },
  filters: {
    moment: function(date) {
      var d = moment(date);
      return date && d.isValid() ? d.format('DD-MM-YYYY') : '';

    }
  },
  methods: {

    async callParent() {
      this.showadd = false;
      this.$parent.showParent();
		},
		showForm() {
			this.showadd = true;
		},
    print(mnid) {
      const d = new Printd();
      var buffer = '';
      var cssText = `

:show-pagination="false"
   body{
  -webkit-print-color-adjust:exact;
  overflow: auto;
  height: auto;
}
   table {
       border-collapse: collapse;
       margin-left:0px !important;
   }

   .scroll-y {
      height: auto;
      overflow: visible;
   }
   table, td, th {
     border-style: solid;
border-width: 1px;

margin-bottom: 10px;
border-color: rgba(0,0,255,0.25);
       padding:5px;
   }
   .mytablenew{
     border-style: solid;
border-width: 1px;

margin-bottom: 10px;
border-color: white;
       padding:5px;
   }
 pre {
   color: #c7254e;
 }
 .text-right{
   text-align:right;
 }

 .clientdetails{
   margin-top:-40px;
   font-size:12px;
 }

 @media print {
 .text-primary th{
   background-color:rgb(226, 216, 216) !important;
   color:black !important;
   font-size:20px !important;
 }

}
`
      if (document.title != null || document.title != '') {
        let todaydate = new Date();
        let formattedDate = moment(todaydate).format('DD-MM-YYYY HH:mm:ss');
        document.title = 'Manifest-' + mnid + '_' + formattedDate;
      }
      d.print(document.getElementById('printManifestContent'), cssText);
      document.title = 'Xpressbees - Fullfillment Center'
    },
    //open new form(popup)
    getPrintManifestData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      if (this.id == 0 || this.id == '' || !this.id)
        this.$router.push('/manifestdetails')
      this.paginationflag = true;
      var userdetail = this.getLocalUserData();
      if (userdetail) {
        this.loginUserEmail = userdetail.email;
        // this.warehouseid = userdetail.warehouseid;
      }
      if (this.user_type == 'client_user') {
        // this.$route.query.clientid = userdetail.clientid;
        this.clientid1 = userdetail.clientid;

      }
      // if (this.user_type == 'warehouse_user') {
      //   this.warehouseid = userdetail.warehouseid;
      // }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getManifestDetails',
          'data': {
            'clientid': localStorage.getItem("selectedClient"),
            'warehouseid': localStorage.getItem("selectedWarehouse"),
            'id': this.id
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (result) {
            for (var i = 0; i < result.data.data.length; i++) {
              this.listOrderMasterdata = result.data.data[i];
            }
            this.input = ({
              'id': this.id,
              'warehouseid': localStorage.getItem("selectedWarehouse"),
              'clientid': localStorage.getItem("selectedClient"),
            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getAWBNOList',
                'data': this.input,
                headers: {
                  'Authorization': 'Bearer ' + myStr
                }
              })
              .then(result => {
                if (result) {
                  this.totalAWBNO = result.data.data;
                  let totalRows = result.data.count
                  if (totalRows < 10) {
                    this.pagecount = 1
                  } else {
                    this.pagecount = Math.ceil(totalRows / 10)
                  }
                }
              }, error => {
                console.error(error);
              })
          } else {
            this.$alertify.error("Invalid Manifest Details");

          }

        });
    },
    getPaginationData(currentPage) {
      this.pageno = (currentPage - 1) * 10
      this.getPrintManifestData()
    },

    onLoadingStart() {
      this.loading = true;
    },
    onLoadingEnd() {
      this.loading = false;
    },
    getLocalUserData() {
      var userdetailEncrypt = window.localStorage.getItem('userdetail')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
      return userdetail;
    },
  } // end methods
}


// WEBPACK FOOTER //
// ./src/views/components/manifestdetails/printmanifestdetails.component.js